export const emailFormatter = (e:any) => {
  if (e.value === undefined || e.value === '' || e.value === null || e.value === 'N/A') {
    return 'N/A'
  }
  // return email without '@domain.com'
  if (e.value.substring(0, e.value.lastIndexOf("@") !== undefined)) {
    return e.value.substring(0, e.value.lastIndexOf("@"))
  }
};